import { render, staticRenderFns } from "./QuizStudentAnswerPreview.vue?vue&type=template&id=b63574ec&"
import script from "./QuizStudentAnswerPreview.vue?vue&type=script&lang=js&"
export * from "./QuizStudentAnswerPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports